<template>

  <div class="vat-preview-section">
     <!-- Loading State --> <vat-preview-loading v-if="isLoading" /> <!-- Error State -->
    <div
      v-else-if="hasError"
      class="preview-error"
    >
       <b-alert
        variant="danger"
        show
        class="mb-0"
        >
        <div class="d-flex align-items-center justify-content-between">

          <div> <i class="fas fa-exclamation-circle mr-2"></i> {{ errorMessage }} </div>
           <b-button
            size="sm"
            variant="outline-danger"
            @click="fetchPreview"
            > <i class="fas fa-redo mr-1"></i>Thử lại </b-button
          >
        </div>
         </b-alert
      >
    </div>
     <!-- Loaded State --> <template v-else-if="previewData"
      > <!-- Summary Section (Top) --> <!-- <vat-preview-summary :summary="previewData.summary" /> -->
      <!-- Bills Accordion Section -->
      <div class="bills-section">

        <div class="bills-header">
           <i class="fas fa-list-alt mr-2"></i> <span>CHI TIẾT THEO TỪNG HÓA ĐƠN</span> <b-badge
            variant="light"
            class="ml-2"
            >{{ previewData.bills.length }}</b-badge
          >
        </div>

        <div class="bills-list">
           <vat-preview-bill-group
            v-for="(bill, index) in previewData.bills"
            :key="bill.billId"
            :bill="bill"
            :default-expanded="index === 0"
          />
        </div>

      </div>
       </template
    > <!-- Empty State -->
    <div
      v-else
      class="preview-empty"
    >
       <i class="fas fa-calculator text-muted"></i> <span class="text-muted">Chưa có dữ liệu</span>
    </div>

  </div>

</template>

<script>
  import { mapGetters } from 'vuex'
  import { EINVOICE_PREVIEW_CALCULATION } from '@/core/services/store/modules/einvoice/einvoice.module'
  import VatPreviewLoading from './VatPreviewLoading.vue'
  // import VatPreviewSummary from './VatPreviewSummary.vue';
  import VatPreviewBillGroup from './VatPreviewBillGroup.vue'

  export default {
    name: 'VatPreviewSection',

    components: {
      VatPreviewLoading,
      // VatPreviewSummary,
      VatPreviewBillGroup,
    },

    props: {
      invoices: {
        type: Array,
        default: () => [],
      },
      saleType: {
        type: String,
        required: true,
        default: 'RETAIL',
      },
      autoFetch: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      ...mapGetters(['vatPreviewIsLoading', 'vatPreviewData', 'vatPreviewError']),

      isLoading() {
        return this.vatPreviewIsLoading
      },

      hasError() {
        return !!this.vatPreviewError
      },

      errorMessage() {
        if (!this.vatPreviewError) return ''
        return this.vatPreviewError.message || 'Không thể tải preview. Vui lòng thử lại.'
      },

      previewData() {
        return this.vatPreviewData
      },
    },

    watch: {
      invoices: {
        immediate: true,
        handler(newVal, oldVal) {
          if (this.autoFetch && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            this.fetchPreview()
          }
        },
      },

      previewData(newVal) {
        if (newVal) {
          this.$emit('preview-loaded', newVal)
        }
      },

      vatPreviewError(newVal) {
        if (newVal) {
          this.$emit('preview-error', newVal)
        }
      },
    },

    methods: {
      async fetchPreview() {
        const normalizedInvoices = Array.isArray(this.invoices)
          ? this.invoices
              .map((invoice) => {
                const salesInvoiceId =
                  typeof invoice?.salesInvoiceId === 'string'
                    ? invoice.salesInvoiceId.trim()
                    : invoice?.salesInvoiceId
                const hasOverride =
                  invoice &&
                  typeof invoice === 'object' &&
                  Object.prototype.hasOwnProperty.call(invoice, 'override')

                if (!salesInvoiceId || !hasOverride) {
                  return null
                }

                return {
                  salesInvoiceId,
                  override: invoice.override,
                }
              })
              .filter(Boolean)
          : []

        if (!normalizedInvoices.length) return

        try {
          await this.$store.dispatch(EINVOICE_PREVIEW_CALCULATION, {
            saleType: this.saleType,
            invoices: normalizedInvoices,
          })
        } catch {
          // Error handled via store state
        }
      },

      refresh() {
        this.fetchPreview()
      },
    },
  }
</script>

<style lang="scss" scoped>
  $draft-primary: #3699ff;
$draft-text: #3f4254;
$draft-text-muted: #6c757d;
$draft-bg: #f3f6f9;
$draft-border: #ebedf3;

.vat-preview-section {
  // Container styles if needed
}

.preview-error {
  .b-alert {
    font-size: 0.82rem;
  }
}

.preview-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  gap: 0.5rem;
  background: $draft-bg;
  border-radius: 0.375rem;

  i {
    // font-size: 1.5rem;
  }

  span {
    // font-size: 0.82rem;
  }
}

.bills-section {
  margin-top: 0.75rem;
}

.bills-header {
  display: flex;
  align-items: center;
  padding: 0 0 0.7rem;
  font-weight: 700;
  color: $draft-text-muted;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 0.74rem;

  .badge {
    background: rgba($draft-text-muted, 0.12);
    color: $draft-text-muted;
    font-weight: 600;
  }

  i {
    color: rgba($draft-primary, 0.72);
  }
}

.bills-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
